import { COLORS } from '@btime/constants'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { HorizontalLine } from '../../../../../../../components/shapes/Line'
import { Title } from '../../../../../../../packages/kiti/components/presentation/Text'
import { useChecklistFormActions, useSelectedQuestion } from '../../../../_form/ChecklistFormHandler'
import Separator from '../../../../../../../packages/kiti/components/helpers/Separator'
import MaskSelect from '../../../../../../../containers/mask/select/MaskSelect'

const MaskSection = () => {
  const { t } = useTranslation('editChecklist')
  const { handleSelectedQuestionChangeOnPath } = useChecklistFormActions()
  const selectedQuestion = useSelectedQuestion()
  if (selectedQuestion?.questionType?.name !== 'text') return false

  return (
    <>
      <Separator weight={6} />
      <Title size="h7" color={COLORS.dark4}>
        {t('configureMask')}
      </Title>
      <HorizontalLine thin lineColor={COLORS.light2} />
      <Separator weight={4} />

      <MaskSelect onChange={handleSelectedQuestionChangeOnPath(['masks'])} value={selectedQuestion.masks} />
    </>
  )
}

export default MaskSection
